// PageTask Component

import React from 'react'

import app from '../../../app.jsx'
import eventfilters from '../../../lib/eventfilters.jsx'
import PageHeader from '../../layout/page_header/page_header.jsx'
import PageDetail from '../../page/page_detail/page_detail.jsx'
import PlannerPageProvider from '../../../lib/planner_pageprovider.jsx'

class PageTask extends PageDetail {
  constructor (props) {
    super(props, 'plannertask', 'planner')

    this.data = {
      pageState: {
        filters: [],
        visibleObjects: ['task'],
        filter: {}
      },
      histories: [],
      tasks: [],
      projects: [],
      skillOptions: [],
      currentEditObject: null,
      activeTask: null,
      showProjectInfo: true
    }

    this._references = {
      sidebarTask: React.createRef(),
      dialogTimeCardDetail: React.createRef(),
      uploadErrorDialog: React.createRef()
    }
  }

  static get propTypes () {
    return {}
  }

  static get defaultProps () {
    return {}
  }

  componentDidMount () {
    this._getData(false)
    this._initEvents()
  }

  componentWillUnmount () {
    this._bUnMounted = true
    this._releaseEvents()
  }

  isSidebarCollapsed () {
    return true
  }

  canShowCollapse () {
    return false
  }

  /* Data functions */
  _getData (bReload) {
    const params = {
      query: {
        pageIdent: this._pageIdent,
        bUpdatePageState: bReload,
        pageState: this.data.pageState
      }
    }

    app
      .service('/api/page/plannertask')
      .find(params)
      .then((taskRes) => {
        this._onPageDataRecieved(taskRes.pageData)
        this.data.tasks = taskRes.tasks || []
        this.data.histories = taskRes.histories || []

        if (taskRes.projectOptions) {
          this.data.projects = taskRes.projectOptions || []
        }

        if (taskRes.skillOptions) {
          this.data.skillOptions = taskRes.skillOptions || []
        }

        const pageState =
          this._getPageUserState(
            taskRes.pageData ? taskRes.pageData.userState : null
          ) || this.data.pageState
        pageState.filters = pageState.filters || []

        this.data.pageState = pageState

        this._onDataReceived(null)
      })
      .catch((err) => {
        this._onDataReceived(err)
      })
  }

  _reloadData () {
    this._getData(true)
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageTask: _onDataReceived Error', err)
      this.setState({ dataDate: new Date() })
    } else {
      app.debug('PageTask: _onDataReceived [done]')
      this.setState({ dataDate: new Date() })
    }
  }

  /* Realtime Events */
  _initEvents () {
    this._initTaskEvents()
    this._initTimerEvents(this._onReloadTimer.bind(this))
  }

  _releaseEvents () {
    this._releaseTaskEvents()
    this._releaseTimerEvents()
  }

  _eventReloadTask (objectName, eventName, eventData) {
    if (eventfilters.teamFilter(eventData)) {
      app.debug(`-- Event - PageTask - ${objectName} - ${eventName} --`)
      this._reloadData()
    }
  }

  _onReloadTimer (eventData) {
    if (eventfilters.teamFilter(eventData)) {
      this._reloadData()

      if (this.data.activeTask) {
        this._createOrUpdateTask(this.data.activeTask)
        this.data.activeTask = null
      }
    }
  }

  /* Render functions */
  renderContent () {
    return this._renderTaskContent()
  }

  renderRightSidebar () {
    const { projects, skillOptions } = this.data
    return this._renderRightSidebarTask(projects, skillOptions)
  }

  /* Header Functions - START */
  renderHeader () {
    const tabs = [
      {
        ident: 'planner',
        title: 'plannerv2.pageheader.tabPlanner',
        showFavourite: true
      },
      {
        ident: 'plannertask',
        title: 'plannerv2.pageheader.tabTask',
        showFavourite: true
      }
    ]

    return (
      <PageHeader
        title='plannerv2.pageheader.headerTitleTask'
        subtitle='plannerv2.pageheader.headerSubtitleTask'
        icon='tasks'
        favoriteTab={this._getUserFavoriteTab('planner') || 'planner'}
        showTabs
        activeTab='plannertask'
        tabs={tabs}
        onTabChange={this._onHeaderTabChange.bind(this)}
        onToggleFavorite={this._onHeaderToggleFavorite.bind(this)}
      />
    )
  }

  _onHeaderTabChange (tab) {
    app.changePage(tab.ident)
  }

  _onHeaderToggleFavorite (tab) {
    this._updateUserStateFavorite('planner', tab.ident)
    this.setState({ dataDate: new Date() })
  }

  /* Header Functions - END */
}

export default PlannerPageProvider(PageTask)
